import React,{useState} from 'react'
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

function HeadGraphs() {
      // Sample data for the line chart
  const lineData = [
    { month: 'Mar', income: 5200, spending: 4800 },
    { month: 'Apr', income: 6200, spending: 4500 },
    { month: 'May', income: 6400, spending: 6200 },
    { month: 'Jun', income: 6400, spending: 6800 },
    { month: 'Jul', income: 6400, spending: 6600 },
    { month: 'Aug', income: 6200, spending: 4800 },
    { month: 'Sep', income: 6400, spending: 5600 },
    { month: 'Oct', income: 6200, spending: 3200 },
    { month: 'Nov', income: 400, spending: 200 },
    { month: 'Dec', income: 200, spending: 100 },
    { month: 'Jan', income: 5800, spending: 4800 },
    { month: 'Feb', income: 5200, spending: 4600 }
  ];

  // Data for the pie chart
  const pieData = [
    { name: 'Expenses', value: 26025.25, color: '#FF4B6E' },
    { name: 'Bills', value: 503.00, color: '#4ECDC4' },
    { name: 'Savings', value: 20680.00, color: '#8B5FBF' },
    { name: 'Debts', value: 4300.00, color: '#4A90E2' },
    { name: 'Amount Left', value: 9591.75, color: '#E5E5E5' }
  ];

  const distributionData = [
    { label: 'Money In', value: '60,600.00', icon: '↗️' },
    { label: 'Previous Balance', value: '500.00', icon: '💰' },
    { label: 'Total', value: '61,100.00', highlight: true }
  ];

  const breakdownData = [
    { label: 'Expenses', value: '26,025.25', color: '#FF4B6E', percentage: '42%' },
    { label: 'Bills', value: '503.00', color: '#4ECDC4', percentage: '1%' },
    { label: 'Savings', value: '20,680.00', color: '#8B5FBF', percentage: '34%' },
    { label: 'Debts', value: '4,300.00', color: '#4A90E2', percentage: '7%' },
    { label: 'Amount Left', value: '9,591.75', color: '#E5E5E5', percentage: '16%' }
  ];

  return (
  <div style={{
      background: 'white',
      width:"100%",
      // minHeight: '100vh',
      // fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      padding: '2rem',
      // background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)'
    }}>
      <div style={{
        // maxWidth: '1400px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '3rem',
        alignItems: 'stretch'
      }}>
        
        {/* Income & Spending Chart */}
        <div style={{
          background: 'white',
          borderRadius: '24px',
          padding: '2rem',
          // boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(226, 232, 240, 0.8)',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}>
          {/* Subtle background pattern */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 80%, rgba(76, 205, 196, 0.02) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 75, 110, 0.02) 0%, transparent 50%)',
            pointerEvents: 'none'
          }} />
          
          <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: '2rem'
            }}>
              <div style={{
                animation: 'slideInLeft 0.8s ease-out'
              }}>
                <h2 style={{
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  margin: '0 0 0.5rem 0',
                  letterSpacing: '-0.025em'
                }}>
                  Income & Spending
                </h2>
                <p style={{
                  fontSize: '0.875rem',
                  color: '#64748b',
                  margin: 0,
                  fontWeight: '500'
                }}>
                  (expenses + bills + debts + savings)
                </p>
              </div>
              
              <div style={{
                display: 'flex',
                gap: '1.5rem',
                alignItems: 'center',
                animation: 'slideInRight 0.8s ease-out'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 1rem',
                  background: 'rgba(76, 205, 196, 0.1)',
                  borderRadius: '12px',
                  border: '1px solid rgba(76, 205, 196, 0.2)',
                  animation: 'fadeInUp 1s ease-out 0.3s both'
                }}>
                  <div style={{
                    width: '8px',
                    height: '8px',
                    background: '#4ECDC4',
                    borderRadius: '50%',
                    animation: 'pulse 2s infinite'
                  }} />
                  <span style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#0f766e'
                  }}>
                    6,400.00 Max. Income
                  </span>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 1rem',
                  background: 'rgba(255, 75, 110, 0.1)',
                  borderRadius: '12px',
                  border: '1px solid rgba(255, 75, 110, 0.2)',
                  animation: 'fadeInUp 1s ease-out 0.5s both'
                }}>
                  <div style={{
                    width: '8px',
                    height: '8px',
                    background: '#FF4B6E',
                    borderRadius: '50%',
                    animation: 'pulse 2s infinite 0.5s'
                  }} />
                  <span style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#be123c'
                  }}>
                    6,540.00 Max. Spending
                  </span>
                </div>
              </div>
            </div>

            {/* Chart Container - Takes remaining space and positioned at bottom */}
            <div style={{ 
              flex: 1,
              display: 'flex',
              alignItems: 'flex-end',
              animation: 'chartSlideUp 1.2s ease-out 0.7s both'
            }}>
              <div style={{ 
                width: '100%',
                height: '320px'
              }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={lineData}>
                    <XAxis 
                      dataKey="month" 
                      axisLine={false}
                      tickLine={false}
                      tick={{
                        fontSize: 14,
                        fill: '#64748b',
                        fontWeight: 600
                      }}
                      dy={15}
                    />
                    <YAxis 
                      axisLine={false}
                      tickLine={false}
                      tick={{
                        fontSize: 14,
                        fill: '#64748b',
                        fontWeight: 600
                      }}
                      dx={-15}
                      tickFormatter={(value) => `₹${(value/1000).toFixed(0)}k`}
                    />
                    <Line
                      type="monotone"
                      dataKey="income"
                      stroke="#4ECDC4"
                      strokeWidth={4}
                      strokeDasharray="10 5"
                      dot={false}
                      activeDot={{
                        r: 8,
                        fill: '#4ECDC4',
                        stroke: 'white',
                        strokeWidth: 4
                      }}
                    />
                    <Line
                      type="monotone"
                      dataKey="spending"
                      stroke="#FF4B6E"
                      strokeWidth={4}
                      dot={false}
                      activeDot={{
                        r: 8,
                        fill: '#FF4B6E',
                        stroke: 'white',
                        strokeWidth: 4
                      }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          
          {/* Custom CSS animations */}
          <style jsx>{`
            @keyframes slideInLeft {
              from {
                opacity: 0;
                transform: translateX(-30px);
              }
              to {
                opacity: 1;
                transform: translateX(0);
              }
            }
            
            @keyframes slideInRight {
              from {
                opacity: 0;
                transform: translateX(30px);
              }
              to {
                opacity: 1;
                transform: translateX(0);
              }
            }
            
            @keyframes fadeInUp {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            
            @keyframes chartSlideUp {
              from {
                opacity: 0;
                transform: translateY(40px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            
            @keyframes pulse {
              0%, 100% {
                opacity: 1;
                transform: scale(1);
              }
              50% {
                opacity: 0.7;
                transform: scale(1.1);
              }
            }
          `}</style>
        </div>

        {/* Money Distribution */}
        <div style={{
          background: 'white',
          borderRadius: '24px',
          padding: '2rem',
          // boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(226, 232, 240, 0.8)',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background pattern */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 70% 30%, rgba(139, 95, 191, 0.02) 0%, transparent 50%), radial-gradient(circle at 30% 70%, rgba(74, 144, 226, 0.02) 0%, transparent 50%)',
            pointerEvents: 'none'
          }} />
          
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              <div>
                <h2 style={{
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  margin: '0 0 0.25rem 0',
                  letterSpacing: '-0.025em'
                }}>
                  Money Distribution
                </h2>
                <p style={{
                  fontSize: '0.875rem',
                  color: '#64748b',
                  margin: 0,
                  fontWeight: '500'
                }}>
                  (Annual)
                </p>
              </div>
              
              <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '12px',
                padding: '0.5rem',
                color: 'white'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                </svg>
              </div>
            </div>

            {/* Money flow summary */}
            <div style={{
              display: 'grid',
              gap: '1rem',
              marginBottom: '2rem'
            }}>
              {distributionData.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '1rem 1.5rem',
                  background: item.highlight 
                    ? 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' 
                    : 'rgba(248, 250, 252, 0.5)',
                  borderRadius: '16px',
                  border: item.highlight 
                    ? '2px solid rgba(59, 130, 246, 0.3)' 
                    : '1px solid rgba(226, 232, 240, 0.6)',
                  ...(item.highlight && {
                    transform: 'scale(1.02)',
                    // boxShadow: '0 4px 20px rgba(59, 130, 246, 0.1)'
                  })
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}>
                    <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
                    <span style={{
                      fontSize: item.highlight ? '1.125rem' : '1rem',
                      fontWeight: item.highlight ? '700' : '600',
                      color: item.highlight ? '#1e40af' : '#374151'
                    }}>
                      {item.label}
                    </span>
                  </div>
                  <span style={{
                    fontSize: item.highlight ? '1.25rem' : '1.125rem',
                    fontWeight: '700',
                    color: item.highlight ? '#1e40af' : '#1e293b',
                    fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace'
                  }}>
                    ₹{item.value}
                  </span>
                </div>
              ))}
            </div>

            {/* Main Chart and Detailed Breakdown */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '2rem',
              height: '100%'
            }}>
              {/* Chart and Summary Side by Side */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2rem',
                minHeight: '280px'
              }}>
                {/* Pie Chart */}
                <div style={{ 
                  flex: '0 0 260px',
                  height: '260px', 
                  position: 'relative'
                }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={65}
                        outerRadius={110}
                        dataKey="value"
                        startAngle={90}
                        endAngle={450}
                      >
                        {pieData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                  
                  {/* Center text */}
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    background: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '50%',
                    width: '90px',
                    height: '90px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(10px)',
                    border: '3px solid rgba(59, 130, 246, 0.1)'
                  }}>
                    <div style={{
                      fontSize: '1.125rem',
                      fontWeight: '800',
                      color: '#1e293b',
                      fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace'
                    }}>
                      ₹61,600
                    </div>
                    <div style={{
                      fontSize: '0.6rem',
                      color: '#64748b',
                      fontWeight: '600',
                      marginTop: '0.25rem',
                      letterSpacing: '0.5px'
                    }}>
                      TOTAL
                    </div>
                  </div>
                </div>

                {/* Quick Summary Cards */}
                <div style={{ 
                  flex: 1,
                  display: 'grid', 
                  gridTemplateColumns: '1fr 1fr',
                  gap: '1rem'
                }}>
                  {/* Expenses */}
                  <div style={{
                    background: 'linear-gradient(135deg, #FF4B6E05 0%, #FF4B6E15 100%)',
                    padding: '1.5rem',
                    borderRadius: '16px',
                    border: '2px solid #FF4B6E20',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      fontSize: '1.5rem',
                      fontWeight: '800',
                      color: '#FF4B6E',
                      fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                      marginBottom: '0.5rem'
                    }}>
                      ₹26,025
                    </div>
                    <div style={{
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '0.5rem'
                    }}>
                      Expenses
                    </div>
                    <div style={{
                      background: '#FF4B6E',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.75rem',
                      fontWeight: '700',
                      display: 'inline-block'
                    }}>
                      42%
                    </div>
                  </div>

                  {/* Savings */}
                  <div style={{
                    background: 'linear-gradient(135deg, #8B5FBF05 0%, #8B5FBF15 100%)',
                    padding: '1.5rem',
                    borderRadius: '16px',
                    border: '2px solid #8B5FBF20',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      fontSize: '1.5rem',
                      fontWeight: '800',
                      color: '#8B5FBF',
                      fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                      marginBottom: '0.5rem'
                    }}>
                      ₹20,680
                    </div>
                    <div style={{
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '0.5rem'
                    }}>
                      Savings
                    </div>
                    <div style={{
                      background: '#8B5FBF',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.75rem',
                      fontWeight: '700',
                      display: 'inline-block'
                    }}>
                      34%
                    </div>
                  </div>

                  {/* Debts */}
                  <div style={{
                    background: 'linear-gradient(135deg, #4A90E205 0%, #4A90E215 100%)',
                    padding: '1.5rem',
                    borderRadius: '16px',
                    border: '2px solid #4A90E220',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      fontSize: '1.5rem',
                      fontWeight: '800',
                      color: '#4A90E2',
                      fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
                      marginBottom: '0.5rem'
                    }}>
                      ₹4,300
                    </div>
                    <div style={{
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '0.5rem'
                    }}>
                      Debts
                    </div>
                    <div style={{
                      background: '#4A90E2',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.75rem',
                      fontWeight: '700',
                      display: 'inline-block'
                    }}>
                      7%
                    </div>
                  </div>

                  {/* Bills & Amount Left Combined */}
                  <div style={{
                    background: 'linear-gradient(135deg, #4ECDC405 0%, #E5E5E515 100%)',
                    padding: '1rem',
                    borderRadius: '16px',
                    border: '2px solid #4ECDC420',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem'
                  }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <div>
                        <div style={{
                          fontSize: '1rem',
                          fontWeight: '700',
                          color: '#4ECDC4',
                          fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace'
                        }}>
                          ₹503
                        </div>
                        <div style={{
                          fontSize: '0.75rem',
                          fontWeight: '600',
                          color: '#374151'
                        }}>
                          Bills
                        </div>
                      </div>
                      <div style={{
                        background: '#4ECDC4',
                        color: 'white',
                        padding: '0.2rem 0.5rem',
                        borderRadius: '8px',
                        fontSize: '0.65rem',
                        fontWeight: '700'
                      }}>
                        1%
                      </div>
                    </div>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <div>
                        <div style={{
                          fontSize: '1rem',
                          fontWeight: '700',
                          color: '#9CA3AF',
                          fontFamily: 'ui-monospace, "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace'
                        }}>
                          ₹9,592
                        </div>
                        <div style={{
                          fontSize: '0.75rem',
                          fontWeight: '600',
                          color: '#374151'
                        }}>
                          Amount Left
                        </div>
                      </div>
                      <div style={{
                        background: '#9CA3AF',
                        color: 'white',
                        padding: '0.2rem 0.5rem',
                        borderRadius: '8px',
                        fontSize: '0.65rem',
                        fontWeight: '700'
                      }}>
                        16%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  )
}

export default HeadGraphs